import { Typography } from '@breetometer/components';
import type { FileType } from 'BreetHelpers';

export const FileNoPreview = ({ mimeType }: { mimeType: FileType | undefined }) => (
	<div className='no-preview'>
		<Typography as='p'>No preview for this file type ( {mimeType} )</Typography>
	</div>
);
